exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.mp-copy-to-clipboard {\n  display: flex;\n  flex-direction: row;\n}\n.copy-input {\n  margin-right: 5px;\n}\n.copy-button {\n  align-self: flex-end;\n  display: flex;\n  position: relative;\n}\n", ""]);

// exports
